import React from "react";

export default function DisplayGearNoClass() {
	return (
		<div>
			<h4 className="gear-title">Choose a class for gear recommendations.</h4>
		</div>
	);
}
